import { jsx as a } from "react/jsx-runtime";
import { c as s } from "./index.CWkFp9WS.js";
import { O as c } from "./ODSColumn.B8Qu83P2.js";
import '../assets/ODSDivider.css';const O = ({
  variant: i = "vertical",
  type: e,
  inset: t = !1,
  spacing: D = !1,
  className: n,
  ...o
}) => {
  const r = e ?? i;
  return e !== void 0 && i === void 0 && console.warn(
    "[ODSDivider] `type` is deprecated—please switch to `variant`."
  ), /* @__PURE__ */ a(
    c,
    {
      className: s(
        "ODSDivider",
        `ODSDivider--variant-${r}`,
        t && "ODSDivider--inset",
        D && "ODSDivider--spacing",
        n
      ),
      ...o,
      children: /* @__PURE__ */ a(
        "div",
        {
          className: s(
            "ODSDivider-rectangle",
            `ODSDivider-rectangle--variant-${r}`
          )
        }
      )
    }
  );
};
export {
  O
};
//# sourceMappingURL=ODSDivider.DGHoVesr.js.map
